export function isVoiceEnabled(context) {
  let config = context.getProvider('channelConfiguration').get();
  let appFeatures = context.getProvider('appFeatures').get();

  return !!(config && config.companyPhoneNumbers().length) && !appFeatures.isEnabled('telephonyApi');
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/voice/is_voice_enabled.js